module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WCdYFM/tc-custom/9781646568529.jpg?1723405210396",
      "alt": "This image is the cover for the book Cosmic"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cosmic\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Can three hearts break harder than two?"), _c('br'), _c('br'), _vm._v("While on a mission, the last thing the crew of the Sovereignty expects is to gain an addition crew-member, but when an unknown assailant attacks, Axel has no choice but to beam the stranger on board the spacecraft. Already in a sexual relationship with Snake, a rare species of alien, Axel certainly isn't looking for another person to complicate his already challenging existence."), _c('br'), _c('br'), _vm._v("The trouble is he cannot deny his growing attraction for the newcomer, who happens to be a striking and intelligent woman. Sela's so intelligent she's already worked out Snake is an alien and the two men are in a somewhat turbulent relationship. Still, Axel isn't the only one who likes Sela. Snake likes her too, and Sela doesn't appear to mind the idea Axel and Snake are lovers, especially after she sees them together ... But can they truly battle their differences and natural distrust, while fighting a corrupt government and dealing with a zealot of a leader?"), _c('br'), _c('br'), _vm._v("One man, one woman, and one alien; two male and one female, all fighting corruption as well as their own desires. In a universe at war it’s natural to keep secrets but can too many confidences mean they’ll never find peace?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Maria Bidwell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0